// extracted by mini-css-extract-plugin
export default {"navbarItem":"NavbarItem_navbarItem__tZQVo","active":"NavbarItem_active__iHHj-"};